import React, { useState, memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './ButtonSubscribe2.module.less';
import {
  handleSubscribeSucc,
  joinSubscribeSuccList,
  handleCancelShow,
} from '../../../actions/layout';
import { emptyLoginClose } from '../../../actions/user';
import { getSubscribedAppList } from '../../../actions/native';
import { createAxios, getSoftType } from '../../../utils/utils';
import { SUBSCRIBE_REPOET_87 } from '../../../config/index';
import Toast from '../../Toast/Toast';
import { logging } from '../../../actions/log';
import useLoginStatus from '../../../utils/hooks/useLoginStatus';
import { handleLogin } from '../../../utils/hooks/useLoginStatus';

const selectSubscribeSuccList = createSelector(
  state => state.layout,
  layout => layout.subscribeSuccList,
);

const selectSubscribeCancelList = createSelector(
  state => state.layout,
  layout => layout.subscribeCancellationList,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const seletUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const seletSubscribedList = createSelector(
  state => state.native,
  native => native.subscribedList,
);

const selectLoginClose = createSelector(
  state => state.user,
  user => user.loginBoxClose,
);

export default memo(({ soft, info = {}, logInfo = {} }) => {
  const dispatch = useDispatch();
  let sub_button = styles.sbutton;
  let sub_buttoned = styles.sbuttoned;
  if (info?.btnStyle === 'black') {
    sub_button = styles.b_sbutton;
    sub_buttoned = styles.b_sbutton_open;
  }
  if (info?.btnStyle === 'opacity') {
    sub_button = styles.g_sbutton;
    sub_buttoned = styles.g_sbutton_open;
  }
  const [buttonText, setButtonText] = useState(info.text ?? '预约');
  const [isSubscribe, setIsSubscribe] = useState(soft?.appBizContent?.isSubscribed === 0 ? 2 : 1); //2 预约 1已预约
  const [isClick, setIsClick] = useState(false); // 判断是否登录
  const subscribeSuccList = useSelector(selectSubscribeSuccList);
  const subscribeCancellationList = useSelector(selectSubscribeCancelList);
  const logInfoData = useSelector(selectLogInfo);
  const loginStatus = useLoginStatus();
  const userInfo = useSelector(seletUserInfo);
  const subscribedAppList = useSelector(seletSubscribedList);
  const loginBoxClose = useSelector(selectLoginClose);

  useEffect(() => {
    let addFind = subscribedAppList.find(e => e === soft?.softID ?? soft?.SoftID);
    if (addFind) {
      setButtonText('已预约');
    } else {
      setButtonText(info.text ?? '预约');
    }
  }, [soft, subscribedAppList]);

  useEffect(() => {
    if (loginStatus && isClick && loginBoxClose?.result === 1) {
      handleSubscribe();
      dispatch(emptyLoginClose());
    }
    if (!loginStatus && isClick && loginBoxClose?.result === 0) {
      setIsClick(false);
      dispatch(emptyLoginClose());
    }
  }, [loginStatus, isClick, loginBoxClose]);

  const GenerateParam2 = () => {
    let param2 = {
      type: isSubscribe === 1 ? 'cbook' : 'book',
      softType: getSoftType(soft),
      softid: soft.softID,
      softName: soft.softName,
      source: logInfo.source,
      source_p: logInfoData.source_p,
      source_pp: logInfoData.source_pp,
    };

    // 当为搜索结果也跳转过来的，带上附加信息
    if (logInfo.isSearch) {
      param2.search_type = logInfoData.search_type;
      param2.search_word = logInfoData.search_word;
    }
    // 联想词softcard  做特殊处理 参数通过 logInfo (即logInfo_para) 传入
    if (
      logInfo.isSearch &&
      (logInfo.search_type === 4 || logInfo.search_type === 5 || logInfo.search_type === 6)
    ) {
      param2.source_p = logInfo.source_p;
      param2.source_pp = logInfo.source_pp;
      param2.search_type = logInfo.search_type;
      param2.search_word = logInfo.search_word;
    }

    // 处理命令行直接跳入搜索结果页面没有search_word的问题
    if (logInfo.isSearch && logInfo.search_word) {
      param2.search_word = logInfo.search_word;
    }

    return param2;
  };

  const handleCancle = useCallback(() => {
    let log = GenerateParam2();

    dispatch(
      logging({
        category: 'C',
        action: 'Install',
        label: '',
        param2: log,
        param3: soft.bizInfo || null,
      }),
    );
    dispatch(
      handleCancelShow({
        isShow: true,
        softId: soft?.softID ?? soft?.SoftID,
        style: info?.btnStyle,
      }),
    );
    setIsClick(false);
  }, []);

  const handleSubscribe = type => {
    let logParam2 = GenerateParam2();

    dispatch(
      logging({
        category: 'C',
        action: 'Install',
        label: '',
        param2: logParam2,
        param3: soft.bizInfo || null,
      }),
    );

    if (loginStatus) {
      createAxios().then(axios => {
        axios
          .get(SUBSCRIBE_REPOET_87, {
            params: { softId: soft?.softID ?? soft?.SoftID, opType: 1 },
          })
          .then(res => {
            if (res?.data?.status === 0) {
              if (res?.data?.data === false) {
                dispatch(
                  logging({
                    category: 'R',
                    action: 'Game_Appoint_Result',
                    label: '',
                    param2: {
                      search_type: logParam2.search_type,
                      softid: logParam2.softid,
                      softType: logParam2.softType,
                      search_word: logParam2.search_word,
                      source_p: logParam2.source_p,
                      source: logParam2.source,
                    },
                    param3: soft.bizInfo || null,
                  }),
                );
                dispatch(
                  handleSubscribeSucc({
                    isShow: true,
                    softId: soft?.softID ?? soft?.SoftID,
                    style: info?.btnStyle,
                  }),
                );
                dispatch(getSubscribedAppList());
                if (typeof window.CallForumUpdateSoftSubscribe === 'function') {
                  window.CallForumUpdateSoftSubscribe();
                }
                if (soft?.appBizContent?.promotionUrl) {
                  window.open(soft?.appBizContent?.promotionUrl);
                }
              }
            } else if (res?.data?.status !== 0) {
              Toast.error({ content: '预约失败，请稍后重试' });
            }
          })
          .catch(() => {
            Toast.error({ content: '预约失败，请稍后重试' });
          });
      });
      // }
      setIsClick(false);
    } else {
      if (loginBoxClose !== null) {
        dispatch(emptyLoginClose());
      }
      handleLogin();
      setIsClick(true);
    }
  };

  return (
    <>
      <div
        className={`${styles.button}
        ${sub_button}
         ${info.className} 
         ${buttonText === '已预约' && sub_buttoned}`}
        onClick={() => (buttonText === '已预约' ? handleCancle() : handleSubscribe())}
      >
        {buttonText}
      </div>
    </>
  );
});
